<template>
    <div style="margin-top:30px;padding-top:4px;border-top:1px solid;">
      <el-form-item :prop="elementDefinition.key">
        <h4>{{elementDefinition.label}}</h4>
        <span style="line-height:1.6!important;" v-html="instructions"></span>
      </el-form-item>
    </div>
</template>

<script>
import * as showdown from "showdown";

export default {
  name: "FormElementSection",
  props: ['elementDefinition'],
  computed: {
    instructions: function () {
      let converter = new showdown.Converter()
      return converter.makeHtml(this.elementDefinition.instructions)
    },
  }
}
</script>

<style scoped>

</style>